import { render } from "./SeriesFilter.vue?vue&type=template&id=ace81d6e&scoped=true"
import script from "./SeriesFilter.vue?vue&type=script&lang=js"
export * from "./SeriesFilter.vue?vue&type=script&lang=js"

import "./SeriesFilter.vue?vue&type=style&index=0&id=ace81d6e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ace81d6e"]])

export default __exports__